import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import axiosInstance from '../Authservices/axiosInstance.js';
import './SigninForm.css';

const Signin = () => {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const [forgotPasswordVisible, setForgotPasswordVisible] = useState(false);
  const [userIdForReset, setUserIdForReset] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const checkSessionExpiry = () => {
      const expiryTime = localStorage.getItem('expiry');
      if (expiryTime && Date.now() > expiryTime) {
        handleLogout();
      }
    };
    const interval = setInterval(checkSessionExpiry, 60000);
    return () => clearInterval(interval);
  }, []);

  const handleLogout = () => {
    localStorage.clear();
    navigate('/signin');
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setLoading(true);
    setError('');
    setForgotPasswordVisible(false);

    if (!username || !password) {
      setError('Please enter username and password.');
      setLoading(false);
      return;
    }

    try {
      // ❌ No role sent anymore
      const response = await axiosInstance.post('user/signin', {
        username,
        password,
      });

      const {
        userId, name, token, refreshToken,
        role: userRole,           // 👈 role comes from the server
        department,
      } = response.data;

      localStorage.setItem('userId', userId);
      localStorage.setItem('name', name);
      localStorage.setItem('username', username);
      localStorage.setItem('accessToken', token);
      localStorage.setItem('refreshToken', refreshToken);
      localStorage.setItem('role', userRole);
      localStorage.setItem('department', department);
      localStorage.setItem('expiry', Date.now() + 3600000);

      // ✅ Route based on the DB role
      if (userRole === 'Admin') {
        navigate('/admin-dashboard');
      } else if (userRole === 'Employee') {
        navigate('/team-chart');
      } else if (userRole === 'HR') {
        navigate('/hr-dashboard');        // 👈 add your HR route
      } else if (userRole === 'Accounts') {
        navigate('/accounts-dashboard');  // 👈 add your Accounts route
      } else {
        setError('Access Denied: Unknown role.');
        localStorage.clear();
      }
    } catch (err) {
      console.error('Error during sign-in:', err);
      if (err.response) {
        setError(err.response.data.message || 'Invalid credentials');
        if (err.response.data.message === 'Incorrect password') {
          setForgotPasswordVisible(true);
          setUserIdForReset(err.response.data.userId);
        }
      } else if (err.request) {
        setError('No response from server. Please try again later.');
      } else {
        setError('Error: ' + err.message);
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page-container">
      <div className="auth-image-wrapper">
        <img src="./logo-ems.jpg" alt="Authentication" className="auth-image" />
      </div>

      <form className="auth-form-container" onSubmit={handleSubmit} autoComplete="off">
        <h2 className="auth-form-title">Sign In</h2>

        {loading && <p className="auth-loading">Loading...</p>}
        {error && <p className="auth-error" style={{ color: 'red' }}>{error}</p>}

        {/* ❌ Role select removed entirely */}

        <div className="auth-input-group">
          <input
            type="text"
            className="auth-input"
            placeholder="Enter Username"
            value={username}
            onChange={(e) => setUsername(e.target.value)}
            autoComplete="off"
            required
          />
        </div>

        <div className="auth-input-group">
          <input
            type="password"
            className="auth-input"
            placeholder="******"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            autoComplete="new-password"
            required
          />
        </div>

        <button className="auth-signin-button" type="submit" disabled={loading}>
          {loading ? 'Signing In...' : 'Sign In'}
        </button>

        <div className={`forgot-password-wrapper ${forgotPasswordVisible ? 'visible' : ''}`}>
          <p className="forgot-password-link">
            Forgot Password?{' '}
            <NavLink to={`/password-reset?userId=${userIdForReset}`}>
              Click Here!
            </NavLink>
          </p>
        </div>
      </form>
    </div>
  );
};

export default Signin;